import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './../assets/logo.png'
import _imports_1 from './../assets/info.png'
import _imports_2 from './../assets/check.png'
import _imports_3 from './../assets/more.png'
import _imports_4 from './../assets/less.png'


const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "meal-type-toggle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[12] || (_cache[12] = _createElementVNode("img", {
      alt: "ambiFOX Logo",
      src: _imports_0,
      class: "bild"
    }, null, -1)),
    _cache[13] || (_cache[13] = _createElementVNode("h1", null, "Hungry? Order!", -1)),
    _createElementVNode("a", {
      href: _ctx.url,
      target: "_blank"
    }, [...(_cache[5] || (_cache[5] = [
      _createElementVNode("img", {
        alt: "menue card",
        src: _imports_1,
        class: "btn btn--min-b-radius"
      }, null, -1)
    ]))], 8, _hoisted_1),
    _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["meal-type-option", { active: _ctx.selectedMealType === 'daily' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectMealType('daily')))
      }, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("img", {
          class: "btn",
          alt: "Tagesgericht auswählen",
          src: _imports_2
        }, null, -1),
        _createElementVNode("span", null, "Tagesgericht", -1)
      ]))], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["meal-type-option", { active: _ctx.selectedMealType === 'weekly' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectMealType('weekly')))
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("img", {
          class: "btn",
          alt: "Wochengericht auswählen",
          src: _imports_2
        }, null, -1),
        _createElementVNode("span", null, "Wochengericht", -1)
      ]))], 2)
    ]),
    _createElementVNode("p", null, [
      _cache[8] || (_cache[8] = _createTextVNode(" Auswahl: ", -1)),
      _createElementVNode("strong", null, _toDisplayString(_ctx.mealTypeLabel), 1)
    ]),
    _createElementVNode("p", null, [
      _cache[9] || (_cache[9] = _createTextVNode(" Please choose your amount of meals for ", -1)),
      _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("strong", null, _toDisplayString(_ctx.next_possible_order_date.toDateString()), 1)
    ]),
    _createElementVNode("p", null, [
      _cache[11] || (_cache[11] = _createTextVNode(" Amount: ", -1)),
      _createElementVNode("strong", null, _toDisplayString(_ctx.order_amount), 1)
    ]),
    _createElementVNode("img", {
      class: "btn",
      alt: "more",
      src: _imports_3,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.increaseAmount && _ctx.increaseAmount(...args)))
    }),
    _createElementVNode("img", {
      class: "btn",
      alt: "less",
      src: _imports_4,
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.decreaseAmount && _ctx.decreaseAmount(...args)))
    }),
    _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
    _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("img", {
      class: "btn",
      alt: "order",
      src: _imports_2,
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.placeOrder && _ctx.placeOrder(...args)))
    })
  ]))
}